<cb-dialog>
    <form class="flex-col flex"
          #categoryForm="ngForm">
        <cb-input type="text"
                  name="name"
                  label="Category Name"
                  [required]="true"
                  [(ngModel)]="mappedItem.name"></cb-input>
        <cb-checkbox name="isActive"
                     label="Is Active"
                     [(ngModel)]="mappedItem.isActive"></cb-checkbox>
    </form>
    <div actions>
        <button mat-raised-button
                color="primary"
                (click)="save()"
                [disabled]="!categoryForm.dirty || !categoryForm.valid || saveInProgress">
            Save
        </button>
        <button mat-raised-button
                (click)="cancel()">
            Cancel
        </button>
    </div>
</cb-dialog>
